import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { toast } from "sonner";
import { errText } from "../lib/errors";

export default function AuthPage() {
  const { login, register, googleLogin } = useAuth();
  const navigate = useNavigate();
  const [lForm, setLForm] = useState({ email: "", password: "" });
  const [rForm, setRForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [busy, setBusy] = useState(false);

  const inputCls = "w-full h-12 px-4 rounded-xl border border-stone-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-forest/30 focus:border-forest";

  const doLogin = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const u = await login(lForm.email, lForm.password); navigate(u.role === "admin" || u.role === "super_admin" ? "/admin" : "/hesap"); }
    catch (err) { toast.error(errText(err) || "Giriş başarısız"); }
    finally { setBusy(false); }
  };

  const doRegister = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await register(rForm); toast.success("Hesabınız oluşturuldu"); navigate("/hesap"); }
    catch (err) { toast.error(errText(err) || "Kayıt başarısız"); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="auth-page" className="max-w-md mx-auto px-4 py-14">
      <div className="bg-white rounded-3xl border border-stone-200/80 p-8 shadow-sm">
        <h1 className="font-serif text-3xl text-forest text-center">Hoş Geldiniz</h1>
        <p className="text-stone-500 text-sm text-center mt-2">Hesabınıza giriş yapın veya üye olun</p>
        <Tabs defaultValue="login" className="mt-7">
          <TabsList className="grid grid-cols-2 w-full bg-cream-dark/70 rounded-xl p-1">
            <TabsTrigger data-testid="tab-login" value="login" className="rounded-lg">Giriş Yap</TabsTrigger>
            <TabsTrigger data-testid="tab-register" value="register" className="rounded-lg">Üye Ol</TabsTrigger>
          </TabsList>
          <TabsContent value="login">
            <form onSubmit={doLogin} className="space-y-4 mt-5">
              <input data-testid="login-email" type="email" required className={inputCls} placeholder="E-posta" value={lForm.email} onChange={(e) => setLForm({ ...lForm, email: e.target.value })} />
              <input data-testid="login-password" type="password" required className={inputCls} placeholder="Şifre" value={lForm.password} onChange={(e) => setLForm({ ...lForm, password: e.target.value })} />
              <button data-testid="login-submit" disabled={busy} className="w-full bg-forest hover:bg-forest-dark disabled:bg-stone-400 text-white font-semibold py-3.5 rounded-xl transition-colors">{busy ? "Giriş yapılıyor..." : "Giriş Yap"}</button>
              <p className="text-right"><Link to="/sifremi-unuttum" data-testid="forgot-password-link" className="text-xs font-semibold text-forest hover:underline">Şifremi Unuttum</Link></p>
            </form>
          </TabsContent>
          <TabsContent value="register">
            <form onSubmit={doRegister} className="space-y-4 mt-5">
              <input data-testid="register-name" required className={inputCls} placeholder="Ad Soyad" value={rForm.name} onChange={(e) => setRForm({ ...rForm, name: e.target.value })} />
              <input data-testid="register-email" type="email" required className={inputCls} placeholder="E-posta" value={rForm.email} onChange={(e) => setRForm({ ...rForm, email: e.target.value })} />
              <input data-testid="register-phone" className={inputCls} placeholder="Telefon (opsiyonel)" value={rForm.phone} onChange={(e) => setRForm({ ...rForm, phone: e.target.value })} />
              <input data-testid="register-password" type="password" required minLength={6} className={inputCls} placeholder="Şifre (en az 6 karakter)" value={rForm.password} onChange={(e) => setRForm({ ...rForm, password: e.target.value })} />
              <button data-testid="register-submit" disabled={busy} className="w-full bg-forest hover:bg-forest-dark disabled:bg-stone-400 text-white font-semibold py-3.5 rounded-xl transition-colors">{busy ? "Kaydediliyor..." : "Üye Ol"}</button>
            </form>
          </TabsContent>
        </Tabs>
        <div className="flex items-center gap-3 my-6"><span className="flex-1 h-px bg-stone-200" /><span className="text-xs text-stone-400">veya</span><span className="flex-1 h-px bg-stone-200" /></div>
        <button data-testid="google-login-button" onClick={googleLogin} className="w-full border-2 border-stone-300 hover:border-forest bg-white font-semibold py-3 rounded-xl transition-colors flex items-center justify-center gap-3 text-sm">
          <svg className="w-5 h-5" viewBox="0 0 24 24"><path fill="#4285F4" d="M23.5 12.3c0-.9-.1-1.5-.3-2.2H12v4.3h6.5c-.1 1.1-.8 2.7-2.4 3.8l3.7 2.9c2.3-2.1 3.7-5.2 3.7-8.8z"/><path fill="#34A853" d="M12 24c3.2 0 6-1.1 7.9-2.9l-3.7-2.9c-1 .7-2.4 1.2-4.2 1.2-3.2 0-6-2.2-7-5.1l-3.9 3C3.1 21.3 7.2 24 12 24z"/><path fill="#FBBC05" d="M5 14.3c-.2-.7-.4-1.5-.4-2.3s.1-1.6.4-2.3l-3.9-3C.4 8.3 0 10.1 0 12s.4 3.7 1.1 5.3l3.9-3z"/><path fill="#EA4335" d="M12 4.7c1.8 0 3 .8 3.7 1.4l3.3-3.2C17.9 1.1 15.2 0 12 0 7.2 0 3.1 2.7 1.1 6.7l3.9 3c1-2.9 3.8-5 7-5z"/></svg>
          Google ile Devam Et
        </button>
        <p className="text-xs text-stone-400 text-center mt-5">Üye olarak <a href="/sayfa/kvkk-aydinlatma-metni" className="underline">KVKK Aydınlatma Metni</a>'ni kabul etmiş olursunuz.</p>
      </div>
    </div>
  );
}
